import { Col, FormGroup, Input, Label, NavLink, Row } from "reactstrap";
import {
  placeholderNoOptions,
  placeholderSelectSimple,
  placeholderText,
} from "../../../../shared/helpers/placeHolders";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { connect } from "react-redux";
import { IRootState } from "../../../../reducers";
import {
  to_ICountry,
  to_ILocality,
  to_IProvince,
  to_ISelect_Entity,
  to_ISelect_Entity_Array,
} from "../../../../shared/mutator/dataTransformSelect";
import { useEffect, useState } from "react";
import { IProvince } from "../../../../shared/model/province.model";
import { ILocality } from "../../../../shared/model/locality.model";
import { provinceOptionsByCountry } from "../../../../shared/selectors/provinceOptions";
import { localitiesOptionsByProvince } from "../../../../shared/selectors/localitiesOptions";
import { customStyles } from "../custom-selector-styles";

interface IProps extends StateProps, DispatchProps {
  formik: any;
  showErrorsInputs: boolean;
}

const animatedComponents = makeAnimated();

export const AddressData = (props: IProps) => {
  const { formik, formData, showErrorsInputs } = props;
  const [provincesState, setProvincesState] = useState<IProvince[]>([]);
  const [localitiesState, setlocalitiesState] = useState<ILocality[]>([]);

  useEffect(() => {
    formik.values?.address?.country;
    const countryId: number = formik.values?.address?.country?.id
      ? formik.values.address.country.id
      : 0;
    const provinceId: number = formik.values?.address?.province?.id
      ? formik.values.address.province.id
      : 0;

    const provincesFiltered: IProvince[] =
      countryId === 0
        ? formData.provinces
          ? formData.provinces
          : []
        : provinceOptionsByCountry(formData.provinces, countryId);

    const localitiesFiltered: ILocality[] =
      provinceId === 0
        ? formData.localities
          ? formData.localities
          : []
        : localitiesOptionsByProvince(formData.localities, provinceId);

    setProvincesState(provincesFiltered);
    setlocalitiesState(localitiesFiltered);
  }, [formik.values.address, formData]);

  const validate = async () => {
    await formik.validateForm();
  };
  useEffect(() => {
    validate();
  }, [formik.values.address.locality]);

  return (
    <>
      {/* DOMICILIO ACTUAL */}
      <Row className="title-form not-first-title">Domicilio actual</Row>
      <Row className="container-inputs-form">
        <Col>
          <FormGroup>
            <Label
              id="streetLabel"
              for="address.street"
              className={
                (showErrorsInputs || formik.touched?.address?.street) &&
                formik.errors?.address?.street &&
                "text-danger"
              }
            >
              Calle*
            </Label>
            <Input
              type="text"
              name="address.street"
              onChange={formik.handleChange("address.street")}
              onBlur={formik.handleBlur("address.street")}
              value={formik.values?.address?.street}
              className={`form-control ${
                (showErrorsInputs || formik.touched?.address?.street) &&
                formik.errors?.address?.street &&
                "is-invalid"
              }`}
              placeholder={placeholderText()}
            />
            {(showErrorsInputs || formik.touched?.address?.street) && formik.errors?.address?.street && (
              <div className="invalid-feedback">
                {formik.errors?.address?.street}
              </div>
            )}
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label
              id="numberLabel"
              for="address.number"
              className={
                (showErrorsInputs || formik.touched?.address?.number) &&
                formik.errors?.address?.number &&
                "text-danger"
              }
            >
              Número*
            </Label>
            <Input
              type="text"
              name="address.number"
              onChange={formik.handleChange("address.number")}
              onBlur={formik.handleBlur("address.number")}
              value={formik.values.address.number}
              className={`form-control ${
                (showErrorsInputs || formik.touched?.address?.number) &&
                formik.errors?.address?.number &&
                "is-invalid"
              }`}
              placeholder={placeholderText()}
            />
            {(showErrorsInputs || formik.touched?.address?.number) && formik.errors?.address?.number && (
              <div className="invalid-feedback">
                {formik.errors?.address?.number}
              </div>
            )}
          </FormGroup>
        </Col>
      </Row>
      <Row className="container-inputs-form">
        <Col>
          <FormGroup>
            <Label id="floorLabel" for="address.floor">
              Piso
            </Label>
            <Input
              type="text"
              name="address.floor"
              onChange={formik.handleChange("address.floor")}
              onBlur={formik.handleBlur("address.floor")}
              value={formik.values?.address?.floor || ""}
              className={`form-control`}
              placeholder={placeholderText()}
            />
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label id="apartmentLabel" for="address.apartment">
              Departamento
            </Label>
            <Input
              type="text"
              name="address.apartment"
              onChange={formik.handleChange("address.apartment")}
              onBlur={formik.handleBlur("address.apartment")}
              value={formik.values?.address?.apartment || ""}
              className={`form-control`}
              placeholder={placeholderText()}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row className="container-inputs-form">
        <Col>
          <FormGroup>
            <Label
              id="zipCodeLabel"
              for="address.zipCode"
              className={
                (showErrorsInputs || formik.touched?.address?.zipCode) &&
                formik.errors?.address?.zipCode &&
                "text-danger"
              }
            >
              Código postal*
            </Label>
            <Input
              type="text"
              name="address.zipCode"
              onChange={formik.handleChange("address.zipCode")}
              onBlur={formik.handleBlur("address.zipCode")}
              value={formik.values.address.zipCode}
              className={`form-control ${
                (showErrorsInputs || formik.touched?.address?.zipCode) &&
                formik.errors?.address?.zipCode &&
                "is-invalid"
              }`}
              placeholder={placeholderText()}
            />
            {(showErrorsInputs || formik.touched?.address?.zipCode) && formik.errors?.address?.zipCode && (
              <div className="invalid-feedback">
                {formik.errors?.address?.zipCode}
              </div>
            )}
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label
              id="countryLabel"
              for="address.country"
              className={
                (showErrorsInputs || formik.touched?.address?.country) && formik.values?.address?.country === null
                  ? "text-danger"
                  : ""
              }
            >
              País*
            </Label>
            <Select
              name="address.country"
              noOptionsMessage={() => placeholderNoOptions()}
              components={animatedComponents}
              options={
                formData.countries
                  ? to_ISelect_Entity_Array(formData.countries)
                  : []
              }
              value={to_ISelect_Entity(formik.values.address.country)}
              onChange={(e: any) => {
                formik.setFieldValue("address.country", to_ICountry(e));
                formik.setFieldValue("address.province", null);
                formik.setFieldValue("address.locality", null);
              }}
              onBlur={formik.handleBlur("address.country")}
              placeholder={placeholderSelectSimple()}
              className={`select-postulate ${
                (showErrorsInputs || formik.touched?.address?.country) &&
                formik.values?.address?.country === null &&
                "is-invalid"
              }`}
              styles={customStyles}
            />
            {(showErrorsInputs || formik.touched?.address?.country) && formik.values?.address?.country === null && (
              <div className="invalid-feedback">
                {formik.errors?.address?.country}
              </div>
            )}
          </FormGroup>
        </Col>
      </Row>
      <Row className="row-zip-code-help">
        <Col className="container-zip-code">
          <NavLink
            href="https://www.correoargentino.com.ar/formularios/cpa"
            target="_blank"
            className="zip-code-link"
            rel="noreferrer"
          >
            ¿Necesitás ayuda? Hace click aquí
          </NavLink>
        </Col>
      </Row>
      <Row className="container-inputs-form">
        <Col>
          <FormGroup>
            <Label
              id="provinceLabel"
              for="address.province"
              className={
                (showErrorsInputs || formik.touched?.address?.province) && formik.values?.address?.province === null
                  ? "text-danger"
                  : ""
              }
            >
              Provincia*
            </Label>
            <Select
              name="address.province"
              noOptionsMessage={() => placeholderNoOptions()}
              components={animatedComponents}
              options={
                formData.provinces
                  ? to_ISelect_Entity_Array(provincesState)
                  : []
              }
              value={to_ISelect_Entity(formik.values.address.province)}
              onChange={(e: any) => {
                formik.setFieldValue("address.province", to_IProvince(e));
                formik.setFieldValue("address.locality", null);
              }}
              onBlur={formik.handleBlur("address.province")}
              placeholder={placeholderSelectSimple()}
              className={`select-postulate ${
                (showErrorsInputs || formik.touched?.address?.province) &&
                formik.values?.address?.province === null &&
                "is-invalid"
              }`}
              styles={customStyles}
            />
            {(showErrorsInputs || formik.touched?.address?.province) && formik.values?.address?.province === null && (
              <div className="invalid-feedback">
                {formik.errors?.address?.province}
              </div>
            )}
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label
              id="localityLabel"
              for="address.locality"
              className={
                (showErrorsInputs || formik.touched?.address?.locality) && formik.values?.address?.locality === null
                  ? "text-danger"
                  : ""
              }
            >
              Localidad*
            </Label>
            <Select
              name="address.locality"
              noOptionsMessage={() => placeholderNoOptions()}
              components={animatedComponents}
              options={
                formData.localities
                  ? to_ISelect_Entity_Array(localitiesState)
                  : []
              }
              value={to_ISelect_Entity(formik.values.address.locality)}
              onChange={(e: any) => {
                formik.setFieldValue("address.locality", to_ILocality(e));
              }}
              onBlur={formik.handleBlur("address.locality")}
              placeholder={placeholderSelectSimple()}
              className={`select-postulate ${
                (showErrorsInputs || formik.touched?.address?.locality) &&
                formik.values?.address?.locality === null &&
                "is-invalid"
              }`}
              styles={customStyles}
            />
            {(showErrorsInputs || formik.touched?.address?.locality) && formik.values?.address?.locality === null && (
              <div className="invalid-feedback">
                {formik.errors?.address?.locality}
              </div>
            )}
          </FormGroup>
        </Col>
      </Row>
      <Row className="container-inputs-form">
        <Col md="6">
          <FormGroup>
            <Label id="districtLabel" for="address.district">
              Barrio
            </Label>
            <Input
              type="text"
              name="address.district"
              onChange={formik.handleChange("address.district")}
              onBlur={formik.handleBlur("address.district")}
              value={formik.values?.address?.district || ""}
              className={`form-control`}
              placeholder={placeholderText()}
            />
          </FormGroup>
        </Col>
      </Row>
    </>
  );
};
const mapStateToProps = (state: IRootState) => {
  return {
    formData: state.postulateReducer.entities,
    loading: state.postulateReducer.loading,
  };
};
const mapDispatchToProps = {};
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(AddressData);
